<template>
  <v-app-bar :clipped-left="clipped" app color="primary" flat>
    <v-app-bar-nav-icon v-if="type !== 'permanent'" color="white" @click.stop="onDrawer()"></v-app-bar-nav-icon>
    <v-toolbar-items>
      <v-btn color="transparent" outlined :to="{path: '/'}">
        <v-img class="primary align-end" width="174" src="@/assets/logo.png" />
      </v-btn>
    </v-toolbar-items>
    <v-spacer></v-spacer>
    <v-btn
      v-if="isAuth && !$vuetify.breakpoint.xs"
      class="mx-2"
      color="white"
      outlined
      :to="{ path: '/desk'}"
    >Desk</v-btn>
    <v-btn
      v-if="isAuth && !$vuetify.breakpoint.xs"
      class="mx-2"
      color="white"
      outlined
      :to="{ path: '/init'}"
    >Setup</v-btn>

    <div v-if="isAuth" class="text-center"></div>
    <v-avatar v-else size="36px">
      <v-icon dark>mdi-account-circle</v-icon>
    </v-avatar>
    <v-btn v-if="isAuth" class="mx-2" color="white" outlined @click="onSignOut">Sign Out</v-btn>
    <v-btn
      v-else
      class="mx-2"
      color="white"
      :loading="loginLoading"
      outlined
      :to="{path: '/login'}"
    >Sign In</v-btn>
  </v-app-bar>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { USER } from "@/store/actions.type";

export default {
  name: "AppBar",
  components: {},
  props: {
    toDrawer: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      drawer: true,
      clippedLeft: true,
      model: null,
      type: "default (no property)",
      clipped: true,
      floating: false,
      mini: false,
      loginLoading: false
    };
  },
  computed: {
    // ...mapGetters(["user"])
    ...mapState({
      errors: state => state.mixin.errors,
      authUser: state => state.user.user
    }),
    ...mapGetters({
      // map `this.doneCount` to `this.$store.getters.doneTodosCount`
      isAuth: "isAuthenticated"
    })
  },
  watch: {
    toDrawer(v) {
      this.drawer = v;
    }
  },
  methods: {
    onDrawer() {
      // if (this.$vuetify.breakpoint.xs) {
      //   this.drawer = false;
      // }
      this.drawer = !this.drawer;
      // console.log(this.drawer);
      this.$emit("fromDrawer", this.drawer);
    },
    onSignOut() {
      this.$store.dispatch(USER.LOGOUT).then(() => {
        this.$router.push({ path: "/" });
      });
    },
    onSignin() {
      if (this.isAuth) {
        this.loginLoading = true;
      }
      this.$router.push("/login");
    },
    goTo(url) {
      if (this.$route.path !== url) this.$router.push(url);
    }
  }
};
</script>

<style></style>
